import styled from 'styled-components';

import { breakpoints } from '@/shared/styles';

export const Content = styled.div`
  display: grid;
  grid-gap: 12px;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  width: 100%;
  z-index: 1;

  @media (min-width: ${breakpoints.tabletLG}px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    grid-gap: 16px;
  }

  @media (min-width: ${breakpoints.laptopSM}px) {
    grid-gap: 32px;
  }
`;
